// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__nUrec","loadingAnimation":"styles_loadingAnimation__Um23-","loader--white":"styles_loader--white__FCCvb","loader--fill":"styles_loader--fill__Fpva6"};